import { render, staticRenderFns } from "./ShowDocumentNew.vue?vue&type=template&id=176f31fc&"
import script from "./ShowDocumentNew.vue?vue&type=script&lang=js&"
export * from "./ShowDocumentNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports